$(document).ready(function(){

$(".collapsible-panel:first-child ").addClass("active");
  
  const homeHeroSlider = $('.home-hero')

  if(homeHeroSlider){
      homeHeroSlider.owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        dots:false,
        items:1,
        autoplay:false,
        autoplaySpeed:3000,
        autoHeight:true,
       autoHeightClass: 'owl-height'
        }) 
    }

  const productSlider = $('.home_product-grid');

    if(productSlider){
      productSlider.owlCarousel({
        loop:true,
        margin:30,
        nav:true,
        dots:false,
        items:2.5,
        autoplay:false,
        autoplaySpeed:3000,
       responsive:{
        0:{
            items:1
        },
        481:{
            items:1.5
        },
        1400:{
            items:2.5
        }
    }
       
        }) 
    }

  const testimonialSlider = $('.customaerslider');

  testimonialSlider.owlCarousel({
    loop:true,
    margin:30,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:1.5,
            nav:true
        },
        1000:{
            items:2.5,
            nav:true,
            loop:true
        }
    }
})


// accordion

const accordions = document.querySelectorAll(".collapsible-panel");
accordFunc();

function accordFunc(){
   
    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".content");
        accordion.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
        };

        const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".content");
        accordion.classList.remove("active");
        content.style.maxHeight = null;
        };

        accordions.forEach((accordion) => {
        const intro = accordion.querySelector(".HelpSupportRight .heading");
        const content = accordion.querySelector(".content");

        intro.onclick = () => {
            if (content.style.maxHeight) {
            closeAccordion(accordion);
            } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(accordion);
            }
        };
        });
}


  
})